/* @flow */

import React from 'react';
import glamorous from 'glamorous';

type Props = {
  children: any,
  icon: any,
};

const Wrapper = glamorous.div({
  alignItems: 'center',
  display: 'flex',
  flexBasis: '100%',
});

const Key = glamorous.span({
  display: 'flex',
  flexBasis: 25,
  flexGrow: 0,
  flexShrink: 0,
});

const Detail = glamorous.span({
  display: 'flex',
  flexShrink: 1,
  paddingLeft: 5,
  textTransform: 'uppercase',
});

function LabelledIcon({ children, icon }: Props) {
  return (
    <Wrapper>
      <Key>{icon}</Key>
      <Detail>{children}</Detail>
    </Wrapper>
  );
}

export default LabelledIcon;
